import { jsxs as r, jsx as l } from "react/jsx-runtime";
import { Group as c } from "../Group/index.js";
import { Text as a } from "../Text/index.js";
import '../../assets/index19.css';const m = "Label-module__asterisk___5fa4G", n = "Label-module__group___4wmpE", u = "Label-module__label___W2uMb", d = "Label-module__rightSection___Dw7cD", e = {
  asterisk: m,
  group: n,
  label: u,
  rightSection: d
}, g = ({ children: o, className: t = "", label: i, rightSection: s, withAsterisk: _ }) => /* @__PURE__ */ r(c, { className: e.group, children: [
  /* @__PURE__ */ l(a, { className: `${e.label} ${t}`, children: o || i }),
  s && /* @__PURE__ */ l("div", { className: e.rightSection, children: s }),
  _ && /* @__PURE__ */ r(a, { "aria-hidden": !0, className: e.asterisk, children: [
    " ",
    "*",
    " "
  ] })
] });
export {
  g as Label
};
